import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TransformedStory } from '../../interfaces/success-story.interface';

@Component({
    selector: 'app-success-story-modal',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    templateUrl: './success-story-modal.component.html',
    styleUrl: './success-story-modal.component.scss',
})
export class SuccessStoryModalComponent {
    @Input() isVisible: boolean = false;
    @Input() storyData: TransformedStory | null = null;
    @Output() closeModal = new EventEmitter<void>();

    onClose() {
        this.closeModal.emit();
    }

    onBackdropClick(event: Event) {
        if (event.target === event.currentTarget) {
            this.onClose();
        }
    }
}
